import React, { Component } from 'react'
import { connect } from 'react-redux'
import numeral from 'numeral'
import moment from 'moment'

import Box from '../components/Layout/Box'
import BoxButton from '../components/Layout/BoxButton'
import ButtonStrip from '../components/Layout/ButtonStrip'
import PermisosGrupo from '../components/Grupos/PermisosGrupo'
import ModalCreate from '../components/Grupos/ModalCreate'
import ModalDelete from '../components/Grupos/ModalDelete'

import {
    getGrupos,
	filterGrupos,
	setOrderBy,
	displayModalCreate,
	showHideModalDelete,
	deleteGrupos,
    showHideModalFilter,
    selectItem,
} from '../actions/grupos'

export const tableCols = [
    { id: 1, caption: 'Nombre', value: 'nombre', type: 'string', format: '', width: '30%' },
    { id: 2, caption: 'Descripción', value: 'descripcion', type: 'string', format: '', width: '70%' },
]

export function findvalues(c, x) {
	let value = x.getIn(c.value.split('.'))
	return value
}

class Grupos extends Component {
    componentWillMount() {
        this.props.getGrupos(1)
    }

	render() {
        const { grupos, orderBy, selected } = this.props

        const boxActions = [
            <BoxButton key="ba[0]" name="plus-circle" onClick={ e => this.props.displayModalCreate(true, 'Creación de grupos', 'create') } title="Nuevo grupo"/>,
            <BoxButton key="ba[1]" name="edit" onClick={ e => this.props.displayModalCreate(true, 'Creación de grupos', 'edit', selected) } title="Modificar grupo" disabled={ selected === null }/>,
            <BoxButton key="ba[2]" name="trash" onClick={ e => this.props.showHideModalDelete(true, `Esta seguro que desea eliminar los Grupos seleccionados?`, () => this.props.deleteGrupos()) } disabled={ grupos.filter(x => x.get('selected')).count() === 0 } danger title="Eliminar parámetro" />,
            <BoxButton key="ba[3]" name="filter" onClick={ e => this.props.showHideModalFilter(true) } title="Filtro"/>,
        ]

		return (
            <div className="row" style={{ height: '100%' }}>
                <div className="col-md-4" style={{ height: '100%' }}>
                    <Box title="Grupos del sistema" stretch>
                        <ButtonStrip 
                            actions={ boxActions }
                        />
                        <div className="box-content" style={{ flex: 1, height: 0, overflow: 'auto' }}>
                            <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-grupos">
                                <thead>
                                    <tr>
                                        {
                                            tableCols.map(x => {
                                                const style = { width: `${x.width}` }
                                                return (
                                                    <th key={ `th1[${x.id}]` } style={ style } onClick={ e => this.props.setOrderBy(x) } className={ (orderBy.get('field') === x.value) ? (orderBy.get('asc') ? 'asc' : 'desc') : '' }>{ x.caption }</th>
                                                )
                                            })
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        grupos.filter(x => x.get('visible')).count() > 0 ? grupos.map((x, n) => {
                                            if (!x.get('visible')) return null
                                            return (
                                                <tr key={ `tr1[${x.get('id')}]` } className={ selected === n ? 'info' : '' } onClick={ () => this.props.selectItem(n) }>
                                                    {
                                                        tableCols.map(c => {
                                                            let alignment = 'left'
                                                            let value = findvalues(c, x)
                                                            if (c.type) {
                                                                switch (c.type) {
                                                                    case 'datetime':
                                                                        value = moment(value).format(c.format)
                                                                        alignment = 'right'
                                                                        break
                                                                    case 'bool':
                                                                        if (typeof value === 'string') value = parseInt(value, 10)
                                                                        value = <div style={{ textAlign: 'center', fontSize: '1.1em' }}><i className={`fa fa-${value ? 'check-' : ''}square`} /></div>
                                                                        break
                                                                    case 'number':
                                                                        value = numeral(value).format(c.format)
                                                                        alignment = 'right'
                                                                        break
                                                                    default:
                                                                }
                                                            }
                                                            const style = { textAlign: alignment }

                                                            if (c.LinkToEdit) {
                                                                return (
                                                                    <td key={ `td1[${x.get('id')}][${c.id}]` } className='LinkToEdit' style={ style } onClick={ e => this.props.displayModalCreate(true, 'Modificación de grupos', 'edit', n) }>{ value }</td>
                                                                )
                                                            } else {
                                                                return (
                                                                    <td key={ `td1[${x.get('id')}][${c.id}]` } style={ style }>{ value }</td>
                                                                )
                                                            }
                                                        })
                                                    }
                                                </tr>
                                            )
                                        }) : <tr><td colSpan={ tableCols.length + 1 }>No existen registros</td></tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </Box>
                </div>
                <div className="col-md-8" style={{ height: '100%' }}>
                    <PermisosGrupo />
                </div>
				<ModalCreate />
                <ModalDelete />
            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        grupos: state.grupos.get('grupos'),
        orderBy: state.grupos.get('orderBy'),
        selected: state.grupos.get('selected')
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getGrupos: (page) => dispatch(getGrupos(page)),
		filterGrupos: (term) => dispatch(filterGrupos(term)),
		setOrderBy: (field) => dispatch(setOrderBy(field)),
		displayModalCreate: (show, title, mode, index) => dispatch(displayModalCreate(show, title, mode, index)),
		showHideModalDelete: (open, message, action) => dispatch(showHideModalDelete(open, message, action)),
		deleteGrupos: () => dispatch(deleteGrupos()),
        showHideModalFilter: (state) => dispatch(showHideModalFilter(state)),
        selectItem: (index) => dispatch(selectItem(index)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Grupos)


// WEBPACK FOOTER //
// ./src/containers/Grupos.jsx